import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { api } from "@/lib/api";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Seo } from "@/components/Seo";

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [missing, setMissing] = useState(false);

  useEffect(() => {
    api.get(`/blog/${slug}`).then((r) => setPost(r.data)).catch(() => setMissing(true));
  }, [slug]);

  return (
    <main className="bg-ink min-h-screen" data-testid="blog-post-page">
      <Seo title={post ? `${post.title} — Haven & Hill Properties` : "Dubai Property Journal — Haven & Hill Properties"}
           description={post?.excerpt} path={`/blog/${slug}`} />
      <Navbar />
      <article className="pt-32 pb-20 max-w-3xl mx-auto px-4 sm:px-6">
        <Link to="/blog" data-testid="blog-back-link"
              className="inline-flex items-center gap-2 text-xs text-zinc-500 hover:text-gold-light transition-colors">
          <ArrowLeft size={14} /> All articles
        </Link>
        {missing && <p className="mt-10 text-zinc-400">Article not found.</p>}
        {post && (
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
            <p className="mt-8 text-[11px] uppercase tracking-[0.25em] text-zinc-500">{post.date}</p>
            <h1 className="mt-3 font-serif text-3xl sm:text-4xl tracking-tight text-[#F8F6F0] leading-tight">{post.title}</h1>
            <div className="mt-8 rounded-2xl overflow-hidden aspect-[21/9]">
              <img src={post.image_url} alt={post.title} className="w-full h-full object-cover" />
            </div>
            <div className="mt-10 space-y-6" data-testid="blog-post-content">
              {post.content.map((block, i) =>
                block.startsWith("## ") ? (
                  <h2 key={i} className="font-serif text-2xl text-gold-pale pt-4">{block.slice(3)}</h2>
                ) : (
                  <p key={i} className="text-sm sm:text-base text-zinc-300 leading-relaxed">{block}</p>
                )
              )}
            </div>
            <div className="mt-12 gold-ring rounded-2xl bg-ink-card p-7 text-center">
              <p className="font-serif text-xl text-[#F8F6F0]">Questions about your own purchase?</p>
              <p className="mt-2 text-sm text-zinc-400">Book a free Zoom or phone consultation with our advisors.</p>
              <Link to="/" state={{ scroll: "booking" }} data-testid="blog-cta-book"
                    className="mt-5 inline-block rounded-full bg-gold px-7 py-3 text-sm font-semibold text-ink hover:bg-gold-hover transition-colors">
                Book a consultation
              </Link>
            </div>
          </motion.div>
        )}
      </article>
      <Footer />
    </main>
  );
}
